import React, { JSX } from 'react';

import { sanitize } from '@ibe/services';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import { Price } from '../../Components/UI/Price/Price';
import Dates from '../Dates';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const Cart = (props: BookedItemComponentProps): JSX.Element => {
  const {
    item,
    relatedItems,
    onDelete,
    onEdit,
    displayExtraServiceDate,
    displayRelatedItems
  } = props;

  const price = item.price || null;
  const description = item.description || null;

  return (
    <div>
      <Row>
        <Col>
          <h6 className="my-0">{item.name}</h6>
        </Col>
        <Col xs={'auto'} className="d-flex justify-content-end align-items-end">
          {onEdit && (
            <Button
              outline
              color="secondary btn-sm"
              onClick={(): void => {
                onEdit(item.id);
              }}
            >
              <FontAwesomeIcon icon={faPenAlt} />
            </Button>
          )}
        </Col>
        <Col xs={'auto'} className="d-flex justify-content-end align-items-end pl-0">
          {onDelete && (
            <Button
              outline
              color="primary btn-sm"
              onClick={(): void => {
                onDelete(item.id);
              }}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
          )}
        </Col>
      </Row>
      <Row>
        {relatedItems && relatedItems.length > 0 ? (
          <>
            <Col xs={'12'}>
              {description && (
                <div
                  className={'iso__extra-cart__description'}
                  dangerouslySetInnerHTML={{ __html: sanitize(description) }}
                />
              )}
            </Col>
            {!displayRelatedItems ||
              (!displayRelatedItems(item) && (
                <Col xs={'12'}>
                  <Row>
                    <Col
                      className={`d-flex align-items-center ${
                        displayExtraServiceDate && !displayExtraServiceDate(item)
                          ? 'justify-content-end'
                          : 'justify-content-between'
                      }`}
                    >
                      {(!displayExtraServiceDate ||
                        (displayExtraServiceDate && displayExtraServiceDate(item))) && (
                        <Dates item={item} />
                      )}
                      <span className="text-muted ml-1">{price && <Price price={price} />}</span>
                    </Col>
                  </Row>
                </Col>
              ))}
            {(!displayRelatedItems || (displayRelatedItems && displayRelatedItems(item))) && (
              <Col xs={'12'}>
                {relatedItems.map(relatedItem => {
                  return (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-between">
                        <Dates item={relatedItem} />
                        <span className="text-muted ml-1">
                          {relatedItem.price && <Price price={relatedItem.price} />}
                        </span>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            )}
          </>
        ) : (
          <>
            <Col>
              {(!displayExtraServiceDate ||
                (displayExtraServiceDate && displayExtraServiceDate(item))) && (
                <Dates item={item} />
              )}
              {description && (
                <div
                  className={'iso__extra-cart__description'}
                  dangerouslySetInnerHTML={{ __html: sanitize(description) }}
                />
              )}
            </Col>
            <Col>
              <span className="text-muted ml-1">{price && <Price price={price} />}</span>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default Cart;
